import { combineReducers } from "redux";
import ClientReducer from "./client-reducer";
import TestReducer from "./test-reducer";

export default combineReducers({
  ClientReducer,
  TestReducer
});
